import * as React from 'react';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';


import HomeIcon from '@mui/icons-material/Home';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import ArticleIcon from '@mui/icons-material/Article';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { makeImportant } from '@utils/cssUtils';
import { brand } from '@templates/shared-theme/themePrimitives';


import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import { AccountContext } from "@context/AccountProvider";

import { RoleWhiteListBasedComponent } from '@component/RoleBasedComponent';
import { Roles } from '@service/roleService';

export default function MenuContent() {
  const location = useLocation();
  const { t } = useTranslation("navigation");
  // const navigate = useNavigate();

  const { sites } = React.useContext(AccountContext);

  const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    '&.Mui-selected': {
      backgroundColor: makeImportant(brand[200]),
      '&:hover': {
        backgroundColor: "green",
      },
    },
  }));

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <Box>
        <List dense>
          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/dashboard'} >
            <StyledListItemButton
              selected={location.pathname === '/admin/dashboard'}> 
              <ListItemIcon> <HomeIcon /></ListItemIcon>
              <ListItemText primary={t("dashboard")} />
            </StyledListItemButton>
          </ListItem>
        </List>
        <Divider />
        <List dense sx={{ pt: 2 }}>
          <ListSubheader>{t('organizationManagement')}</ListSubheader>

          <RoleWhiteListBasedComponent whiteList={[Roles.CLUB_EMPLOYEE, Roles.CLUB_ADMIN]}>
            <ListItem disablePadding sx={
              {
                display: 'block',
                pt: 0
              }
            } component={Link} to={'/admin/club'} >
              <StyledListItemButton selected={location.pathname === '/admin/club'}>
                <ListItemIcon>
                  <GroupsIcon />
                </ListItemIcon>
                <ListItemText primary={t("clubDetails")} />
              </StyledListItemButton>
            </ListItem>
          </RoleWhiteListBasedComponent>

          
          <RoleWhiteListBasedComponent whiteList={[Roles.CLUB_EMPLOYEE, Roles.CLUB_ADMIN]}>
            {sites.length === 1 && (
              <ListItem disablePadding sx={
                {
                  display: 'block',
                  pt: 0
                }
              } component={Link} to={'/admin/site/' + sites[0].uuid} >
                <StyledListItemButton selected={location.pathname.startsWith('/admin/site')}>
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("siteDetails")} />
                </StyledListItemButton>
              </ListItem>
            )}
          </RoleWhiteListBasedComponent>
          

          <RoleWhiteListBasedComponent whiteList={[Roles.SITE_EMPLOYEE, Roles.SITE_ADMIN]}>
            <ListItem disablePadding sx={
              {
                display: 'block',
                pt: 0
              }
            } component={Link} to={'/admin/site/' + sites[0].uuid} >
              <StyledListItemButton selected={location.pathname.startsWith('/admin/site')}>
                <ListItemIcon>
                  <GroupsIcon />
                </ListItemIcon>
                <ListItemText primary={t("siteDetails")} />
              </StyledListItemButton>
            </ListItem>
          </RoleWhiteListBasedComponent>

          <ListItem disablePadding sx={{ display: 'block', pt: 0 }} component={Link} to={'/admin/admin-accounts'} >
            <StyledListItemButton selected={location.pathname === '/admin/admin-accounts'}>
              <ListItemIcon>
                <ManageAccountsIcon />
              </ListItemIcon>
              <ListItemText primary={t("adminAccounts")} />
            </StyledListItemButton>
          </ListItem>
          
        </List>

        <Divider />
        <List dense sx={{ pt: 2 }}>
          <ListSubheader>{t('loyaltyProgram')}</ListSubheader>

          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/shop'} >
            <StyledListItemButton selected={location.pathname === '/admin/shop'}>
              <ListItemIcon>
                <StorefrontIcon />
              </ListItemIcon>
              <ListItemText primary={t("shop")} />
            </StyledListItemButton>
          </ListItem>

          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/rewarded-activities'} >
            <StyledListItemButton selected={location.pathname === '/admin/rewarded-activities'}>
              <ListItemIcon>
                <AttachMoneyIcon />
              </ListItemIcon>
              <ListItemText primary={t("rewardedActivities")} />
            </StyledListItemButton>
          </ListItem>

          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/user-management'} >
            <StyledListItemButton selected={location.pathname === '/admin/user-management'}>
              <ListItemIcon>
                <PeopleAltIcon />
              </ListItemIcon>
              <ListItemText primary={t("userManagement")} />
            </StyledListItemButton>
          </ListItem>

          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/shop/reservations'} >
            <StyledListItemButton selected={location.pathname === '/admin/shop/reservations'}>
              <ListItemIcon>
                <ShoppingCartCheckoutIcon />
              </ListItemIcon>
              <ListItemText primary={t("confirmPurchase")} />
            </StyledListItemButton>
          </ListItem>
        </List>

        <Divider />
        <List dense sx={{ pt: 2 }}>
          <ListSubheader>{t('communication')}</ListSubheader>

          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/communication/posts'} >
            <StyledListItemButton selected={location.pathname === '/admin/communication/posts'}>
              <ListItemIcon>
                <ArticleIcon />
              </ListItemIcon>
              <ListItemText primary={t("posts")} />
            </StyledListItemButton>
          </ListItem>

          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/communication/notifications'} >
            <StyledListItemButton selected={location.pathname === '/admin/communication/notifications'}>
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText primary={t("notifications")} />
            </StyledListItemButton>
          </ListItem>

        </List>

        <Divider />
        <List dense sx={{ pt: 2 }}>
          <ListSubheader>{t('challenges')}</ListSubheader>

          <ListItem disablePadding sx={{ display: 'block' }} component={Link} to={'/admin/challenges'} >
            <StyledListItemButton selected={location.pathname === '/admin/challenges'}>
              <ListItemIcon>
                <EmojiEventsIcon />
              </ListItemIcon>
              <ListItemText primary={t("challenges")} />
            </StyledListItemButton>
          </ListItem>

        </List>
      </Box>

    </Stack>
  );
}
